import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import { TOKENS, TOKEN_CREATED, TOKEN_NAME } from "../../../constants/tokens";
import {
  getTokenTransfers,
  clearTokenTransfers,
} from "../../../containers/TokenTransfers/TokenTransfers.actions";
import { TokenTransfersList } from "../../lists";
import { Card, Radio } from "antd";
import { InteractionOutlined } from "@ant-design/icons";
import "./Transfers.scss";

export default function Transfers({
  defaultToken,
  defaultMaxResults,
  defaultQuerySize,
}) {
  const { status, data, context, error } = useSelector(
    (state: any) => state.TokenTransfers
  );
  const dispatch = useDispatch();

  const [dateRange] = useState([moment(TOKEN_CREATED), moment()]);

  const [token, setToken] = useState(defaultToken);

  const [maxResults] = useState(defaultMaxResults);
  const [querySize] = useState(defaultQuerySize);

  useEffect(() => {
    getTokenTransfers(
      dispatch,
      token,
      dateRange,
      querySize,
      maxResults,
      "component"
    );
  }, [dispatch, token, dateRange, querySize, maxResults]);

  useEffect(() => () => clearTokenTransfers(dispatch), [dispatch]);

  return (
    <Card
      title={
        <div className="Transfers__title">
          <div className="Transfers__title__text">
            <InteractionOutlined
              style={{ fontSize: 27, verticalAlign: -8, marginRight: 6 }}
            />
            Transfers
          </div>
          <Radio.Group
            onChange={(e) => setToken(e.target.value)}
            defaultValue={TOKENS.rise}
          >
            <Radio.Button value={"rise"}>{TOKEN_NAME.rise}</Radio.Button>
            <Radio.Button value={"cash"}>{TOKEN_NAME.cash}</Radio.Button>
          </Radio.Group>
        </div>
      }
      extra={<Link to="/blockchain/transfers">View All</Link>}
      bodyStyle={{ height: 600, overflow: "auto" }}
    >
      <TokenTransfersList
        status={status}
        data={context === "component" ? data : []}
        token={token}
        error={error}
      />
    </Card>
  );
}
